import { onMounted, ref, type Ref } from 'vue';
import { getSearchFormData } from '@/shared/api/getSearchFormData';
import type { Country, DepartureCity, DefaultCriteriaIndex } from '@/shared/model';

export interface UseSearchFormData {
  countries: Ref<Country[]>;
  cities: Ref<DepartureCity[]>;
  defaultCriteria: Ref<DefaultCriteriaIndex>;
  loading: Ref<boolean>;
}

export function useSearchFormData(url?: string): UseSearchFormData {
  const countries = ref<Country[]>([]);
  const cities = ref<DepartureCity[]>([]);
  const defaultCriteria = ref<DefaultCriteriaIndex>({});
  const loading = ref(false);
  const load = async (): Promise<void> => {
    loading.value = true;
    try {
      const data = await getSearchFormData(url);
      countries.value = data.countries;
      cities.value = data.cities;
      defaultCriteria.value = data.defaultCriteria;
    } finally {
      loading.value = false;
    }
  };

  onMounted(() => {
    load();
  });

  return { countries, cities, defaultCriteria, loading };
}
